import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "form"]
  static values = {
    cameraId: String,
    initialValue: String
  }

  declare readonly selectTarget: HTMLSelectElement
  declare readonly formTarget: HTMLFormElement
  declare readonly cameraIdValue: string
  declare readonly initialValueValue: string

  connect() {
    // Store the initial value when the controller connects
    if (!this.initialValueValue) {
      this.initialValueValue = this.selectTarget.value
    }
  }

  async change(event: Event) {
    const select = event.target as HTMLSelectElement
    const newOrgId = select.value
    const selectedOption = select.options[select.selectedIndex]
    const orgName = selectedOption.text

    // Get the confirmation message
    let confirmMessage: string
    if (newOrgId === "") {
      confirmMessage = `Are you sure you want to move this camera to Inventory?`
    } else {
      confirmMessage = `Are you sure you want to assign this camera to "${orgName}"?`
    }

    // Show confirmation dialog
    if (!confirm(confirmMessage)) {
      // User cancelled, revert to initial value
      select.value = this.initialValueValue
      return
    }

    // User confirmed, submit the form
    try {
      this.formTarget.requestSubmit()
      // Update the initial value to the new value after successful submission
      this.initialValueValue = newOrgId
    } catch (error) {
      console.error("Failed to submit form:", error)
      // Revert on error
      select.value = this.initialValueValue
    }
  }
}
